module.exports = __webpack_public_path__ + "img/eye.2a264c42.svg";